import * as React from 'react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { ICreditDetail } from '../../../Model/Questionnaire'
import { inject, observer } from 'mobx-react'

export interface ICreditDetailViewProps {
    creditDetail: ICreditDetail
    className?: string
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class CreditDetailView extends React.Component<ICreditDetailViewProps> {
    render() {
        const { creditDetail, localizationStore, className } = this.props

        if (!creditDetail || !creditDetail.totalSum) {
            return null
        }

        return (
            <div className={className}>
                <div className="row">
                    <div className="col-12 col-sm-8">
                        <span>{localizationStore!.t!('creditSum')}: </span>{creditDetail.totalSum.toFixed(2)}
                    </div>
                    <div className="col-12 col-sm-4">
                        <span>{localizationStore!.t!('totalDpd')}: </span>{creditDetail.dpd}
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/CreditDetailView.tsx